import { defineStore } from "pinia";
import { ref } from "vue";
import { SubscriptionPrice } from "@/types/subscription";
import { fetchSubscriptionPrices } from "@/api/subscription";
import { PremiumCalculator } from "@/types/premiumTypes";

export const useSubscriptionPricesStore = defineStore(
  "subscriptionPrices",
  () => {
    const subscriptionPrices = ref<
      Record<PremiumCalculator, SubscriptionPrice[]>
    >({} as Record<PremiumCalculator, SubscriptionPrice[]>);

    async function getSubscriptionPrices(
      calculator: PremiumCalculator
    ): Promise<SubscriptionPrice[]> {
      if (
        subscriptionPrices.value[calculator] &&
        subscriptionPrices.value[calculator].length > 0
      ) {
        return subscriptionPrices.value[calculator];
      }

      try {
        const prices = await fetchSubscriptionPrices();
        subscriptionPrices.value = prices;

        return prices[calculator];
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    return { getSubscriptionPrices, subscriptionPrices };
  }
);
